/* eslint-disable @typescript-eslint/no-explicit-any */
import TestimonialCard from "../testimonial";
import { EnrollSkeleton } from "./components/loader";
import isEmpty from "lodash/isEmpty";

const Enroll = ({
  isShow,
  isLoading,
  data,
}: {
  isShow?: boolean;
  isLoading?: boolean;
  data?: any;
}) => {
  if (isLoading) return <EnrollSkeleton isShow={isShow} />;
  if (isEmpty(data)) return null;
  return (
    <section className="bg-slate-50 py-12 lg:py-32">
      <div className="container">
        <TestimonialCard data={data} />
      </div>
    </section>
  );
};

export default Enroll;
